import React, { useEffect, useState, useRef } from "react";
import { Chip } from "@mui/material";

const TagInput = ({ onChange, value, validate }) => {
  const [tags, setTags] = useState(value || []);
  const [inputValue, setInputValue] = useState("");
  const [validationError, setValidationError] = useState("");
  const inputRef = useRef(null);

  useEffect(() => {
    setTags(value || []);
  }, [value]);

  const updateTags = (newTags) => {
    const cleanedTags = newTags
      ?.map((tag) => (typeof tag === "string" ? tag.trim() : ""))
      .filter((tag) => tag !== "");
    const uniqueTags = [...new Set(cleanedTags)];
    setTags(uniqueTags);
    if (onChange) {
      onChange(uniqueTags);
    }
  };

  const addTag = (tag) => {
    const trimmedTag = tag?.trim();
    if (trimmedTag === "") return;
    if (validate) {
      const error = validate(trimmedTag);
      if (error) {
        setValidationError(error);
        return;
      }
    }
    setValidationError("");
    if (!tags?.includes(trimmedTag)) {
      updateTags([...tags, trimmedTag]);
    }
  };

  const handleAddTag = (event) => {
    if (
      (event.key === "Enter" || event.key === "Tab") &&
      inputValue?.trim() !== ""
    ) {
      addTag(inputValue);
      setInputValue("");
      event.preventDefault();
    }
  };

  const handleEditTag = (tagToEdit) => {
    setInputValue(tagToEdit);
    updateTags(tags.filter((tag) => tag !== tagToEdit));
  };

  const handleDeleteTag = (tagToDelete) => {
    updateTags(tags.filter((tag) => tag !== tagToDelete));
  };

  const handleBackspace = (event) => {
    if (event.key === "Backspace" && inputValue === "" && tags.length > 0) {
      const lastTag = tags[tags.length - 1];
      updateTags(tags.slice(0, -1));
      if (typeof lastTag === "string") {
        setInputValue(lastTag);
      }
      event.preventDefault();
    }
  };

  const handleBlur = () => {
    if (inputValue?.trim() !== "") {
      addTag(inputValue);
      setInputValue("");
    } else {
      setInputValue("");
      setValidationError("");
    }
  };

  return (
    <div>
      <div
        className="main_tag_input"
        onClick={() => inputRef.current && inputRef.current.focus()}
      >
        {tags?.map((tag, index) => (
          <Chip
            key={index}
            label={tag}
            onDelete={() => handleDeleteTag(tag)}
            onClick={() => handleEditTag(tag)}
          />
        ))}
        <input
          type="text"
          ref={inputRef}
          value={inputValue}
          onChange={(e) => {
            setInputValue(e.target.value);
            if (validationError) setValidationError("");
          }}
          onKeyDown={(e) => {
            handleAddTag(e);
            handleBackspace(e);
          }}
          onBlur={handleBlur}
          fullWidth
        />
      </div>
      {validationError && (
        <div style={{ color: "#d32f2f", fontSize: "0.75rem", marginTop: 4 }}>
          {validationError}
        </div>
      )}
    </div>
  );
};

export default TagInput;
